import Vue from 'vue'
const fetchGoogleMaps = require('fetch-google-maps')

var self = Vue.prototype
Object.defineProperty(self, '$google', {
  get: function () {
    return self.map
  },
  set: function (apiKey) {
    if (self.map !== undefined) return
    self.map = fetchGoogleMaps({
      apiKey: apiKey,
      language: 'en',
      libraries: ['geometry', 'places']
    })
  }
})

export default self



// WEBPACK FOOTER //
// ./src/google.js